
export const FAQList: any = {
    buyerFAQs: {
        "categoryTitle": "Clients FAQs",
        "questions": [
            {
                "question": "How do I fulfill my Gig requirement?",
                "answer": "You can choose a freelancer by reviewing key details such as the description, budget, and timeline. Once you have a choice you can start chatting with the freelancer, negotiate and place an order."
            },
            {
                "question": "How do payments work?",
                "answer": "You fund the project in advance (escrow system). The money is released to the freelancer only after you approve the work. Until then, your money is completely safe."
            },
            {
                "question": "How do refunds work?",
                "answer": "In case of any dispute/discrepancy, upon resolution, the money is refunded back to your account."
            },
            {
                "question": "How do I communicate with freelancers?",
                "answer": "All communication should happen via the in-platform chat to ensure transparency and safety. In case of disputes, NO other mediums of communications will be considered except GenieGig."
            },
            {
                "question": "Does GenieGig provide Video/Audio call support?",
                "answer": "Not yet. But soon, the Call Scheduler feature will be available which will enable video as well as audio calls on GenieGig."
            },
            {
                "question": "How do I find the right freelancer?",
                "answer": "You can browse categories, use filters (skills, ratings, price), and check freelancer profiles, portfolios, and reviews before hiring."
            },
            {
                "question": "Is there a minimum budget for projects?",
                "answer": "No. You can set any budget. However, freelancers usually expect fair rates based on skills and time required."
            },
            {
                "question": "What if I am not satisfied with the work?",
                "answer": "You can request revisions. If issues persist, you can open a dispute, and the platform will mediate."
            },
            {
                "question": "Are there service fees for clients?",
                "answer": "Yes, usually a small percentage is charged on top of the project cost as a platform fee."
            },
            {
                "question": "Can I cancel a project after hiring?",
                "answer": "Yes, but cancellation policies apply. Refunds depend on the progress of work and agreement terms."
            }
        ]
    },
    sellerFAQs: {
        "categoryTitle": "Freelancer FAQs",
        "questions": [
            {
                "question": "How do I create a freelancer profile?",
                "answer": "You need to sign up, add your skills, portfolio, pricing, and services. A well-detailed profile increases your chances of getting hired."
            },
            {
                "question": "Is there a fee to join as a freelancer?",
                "answer": "Joining is free. However, the platform deducts a service commission (usually 10–20%) from each completed order."
            },
            {
                "question": "How do I get paid?",
                "answer": "Payments are transferred to your linked bank account, or UPI once the client approves the final work shared by you along with the original work. The estimated transaction time can be 1-2 days."
            },
            {
                "question": "How do I increase my chances of getting projects?",
                "answer": "Maintain a strong profile, respond quickly to requests, set competitive prices, and deliver high-quality work consistently."
            },
            {
                "question": "Can I offer custom packages to clients?",
                "answer": "Yes, you can create custom offers tailored to the client’s specific needs."
            },
            {
                "question": "How are disputes resolved?",
                "answer": "The platform offers mediation. Both parties present their case, and a resolution is made fairly."
            },
            {
                "question": "Are there penalties for late delivery?",
                "answer": "Yes, late deliveries can affect your ratings and visibility. Always deliver on time or request an extension in advance."
            },
            {
                "question": "Do I get any payment if the client cancels the payment?",
                "answer": "Yes, the money will be credited based on the Refund Terms mentioned in Terms of Service."
            },
            {
                "question": "Can you take a break?",
                "answer": "Yes you can unlist your view and will be delisted within 24 hours. All data will remain. You can enable the listing as per your convenience."
            }
        ]
    }
}
